import React from "react";

type Props = {
  TitleLabel: string;
  Name: string;
  Placeholder?: string;
  Value: string;
  OnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FormInputsNumeric = ({
  TitleLabel,
  Name,
  Placeholder,
  Value,
  OnChange,
}: Props): JSX.Element => {
  const handdleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") e.preventDefault();
  };
  return (
      <div className="form-group">
        <label className="develop___text develop___font_text" htmlFor={Name}>
          {TitleLabel}
        </label>
        <input
          type="text"
          className="form-control develop__inputs"
          id={Name}
          name={Name}
          placeholder={Placeholder}
          onChange={OnChange}
          value={Value}
          onKeyDown={handdleKeyDown}
        />
      </div>
    );
};

export default FormInputsNumeric;
